export const FETCH_RELEASE_BY_ID = "FETCH_RELEASE_BY_ID";
export const SET_RELEASE = "SET_RELEASE";

export const SUBMIT_RELEASE = "SUBMIT_RELEASE";
export const DELETE_RELEASE = "DELETE_RELEASE";
export const CHANGE_RELEASE_STATUS = "CHANGE_RELEASE_STATUS";
